import api from './api';

interface XeroAuthResponse {
  authorizationUrl: string;
}

interface XeroConnectionStatus {
  connected: boolean;
  tenantName?: string;
  tenantId?: string;
  lastSync?: string;
  error?: string;
}

export const xeroApi = {
  // Initiate OAuth connection
  initiateConnection: async (organizationId: string): Promise<XeroAuthResponse> => {
    if (!organizationId) {
      throw new Error('Organization ID is required but not provided.');
    }
    const response = await api.post('/api/integrations/xero/connect', { organizationId });
    return response.data;
  },

  // Check connection status
  getConnectionStatus: async (dataSourceId: string): Promise<XeroConnectionStatus> => {
    const response = await api.get(`/api/integrations/xero/status/${dataSourceId}`);
    return response.data;
  },

  // Disconnect Xero
  disconnect: async (dataSourceId: string): Promise<void> => {
    await api.post(`/api/integrations/xero/disconnect/${dataSourceId}`, {});
  },

  // Trigger manual sync
  syncNow: async (dataSourceId: string): Promise<{ message: string }> => {
    const response = await api.post(`/api/integrations/xero/sync/${dataSourceId}`, {});
    return response.data;
  },
};
